import React from "react";
import { Container } from "react-bootstrap";
import "./LoginFooter.css";
export default function LoginFooter() {
  return (
    <>
      <section className="login-footer py-3 section-spacing-x">
        <Container fluid>
          <div className="d-flex w-100  flex-column-reverse flex-md-row justify-content-between align-items-center">
            <a target="_black" href="https://globaltrendz.com">
              Powered by Global Trendz.
            </a>
            <p className="text-white text-center text-lg-end">
              Copyrights © 2025 <br className="d-md-none" /> SHREEHARI DIAMOND LABORATORY.<br className="d-md-none" /> All rights
              reserved.
            </p>
          </div>
        </Container>
      </section>
    </>
  );
}
